/* eslint-disable react/prefer-stateless-function,react/no-unused-prop-types */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

import {
  selectItemById,
  selectItemsIds,
  sendRequest,
  selectRequestState
} from 'mt-react-common/common/reducers/list/reducer';

import {
  selectRating,
  selectUserId
} from 'mt-react-common/modules/users/common/reducers/states/authAccount';

import RatingStars from '../RatingStars/RatingStars';
import MediumPreLoader from '../../../components/Common/PreLoaders/MediumPreLoader';

const userRatingStatusesListRN =
  'userRatingModule.lists.userRatingStatusesList';

class StatusesDescTable extends Component {
  constructor(props) {
    super(props);
    this.props.sendRequest();
  }

  render() {
    if (this.props.requestState.inProgress) {
      return <MediumPreLoader />;
    }
    return (
      <div className="table-responsive">
        <table className="table table-striped table-text-center">
          <thead>
            <tr>
              <th />
              {this.props.itemsIds.map(itemId => {
                const item = this.props.selectItemById(itemId);
                if (
                  this.props.authUserRating.ratingStatusPoints >=
                    item.pointsFrom &&
                  this.props.authUserRating.ratingStatusPoints <= item.pointsTo
                ) {
                  return (
                    <th
                      key={`userRatingPosition${itemId}`}
                      className="cell-border-primary-top cell-border-primary-right cell-border-primary-left"
                      data-toggle="tooltip"
                      data-placement="top"
                      data-container="body"
                      title={`${this.props.authUserRating.ratingStatusPoints} баллов`}
                    >
                      <i className="fa fa-user" /> {t('Я')}
                      <div className="text-primary">
                        {this.props.authUserRating.ratingStatusPoints}
                      </div>
                    </th>
                  );
                }
                return <th key={`userRatingPosition${itemId}`} />;
              })}
            </tr>
            <tr>
              <th />
              {this.props.itemsIds.map(itemId => {
                const item = this.props.selectItemById(itemId);

                const hasAuthUserStatus =
                  this.props.authUserRating.ratingStatusPoints >=
                    item.pointsFrom &&
                  this.props.authUserRating.ratingStatusPoints <= item.pointsTo;

                let titlePointsRange = '';
                if (
                  itemId !== this.props.itemsIds[this.props.itemsIds.length - 1]
                ) {
                  titlePointsRange = `${t('от')} ${item.pointsFrom} ${t(
                    'до'
                  )} ${item.pointsTo}`;
                } else {
                  titlePointsRange = `${t('от')} ${item.pointsFrom}`;
                }

                return (
                  <th
                    key={`ratingStatusDesc${itemId}`}
                    className={
                      hasAuthUserStatus
                        ? 'cell-border-primary-right cell-border-primary-left'
                        : ''
                    }
                    data-toggle="tooltip"
                    data-placement="top"
                    data-container="body"
                    title={titlePointsRange}
                  >
                    <div className="user-status text-nowrap">
                      <small className="user-status-icon">
                        <RatingStars rating={item.rating} />
                      </small>
                      <div className="user-status-name text-success">
                        {item.title}
                      </div>
                      <small className="user-status-val">
                        {titlePointsRange}
                      </small>
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="text-left">
                {t(
                  'Доходы от рефералов <span class="text-nowrap">1 уровня</span> с выполнения заданий'
                )}
              </td>
              {this.props.itemsIds.map(itemId => {
                const item = this.props.selectItemById(itemId);

                const hasAuthUserStatus =
                  this.props.authUserRating.ratingStatusPoints >=
                    item.pointsFrom &&
                  this.props.authUserRating.ratingStatusPoints <= item.pointsTo;

                return (
                  <td
                    key={`incomeRef1Lvl${itemId}`}
                    className={
                      hasAuthUserStatus
                        ? 'cell-border-primary-right cell-border-primary-left'
                        : ''
                    }
                  >
                    {item.incomeRef1Lvl}%
                  </td>
                );
              })}
            </tr>
            <tr>
              <td className="text-left">
                {t(
                  'Доходы от рефералов <span class="text-nowrap">2 уровня</span> с выполнения заданий'
                )}
              </td>
              {this.props.itemsIds.map(itemId => {
                const item = this.props.selectItemById(itemId);

                const hasAuthUserStatus =
                  this.props.authUserRating.ratingStatusPoints >=
                    item.pointsFrom &&
                  this.props.authUserRating.ratingStatusPoints <= item.pointsTo;

                return (
                  <td
                    key={`incomeRef2Lvl${itemId}`}
                    className={
                      hasAuthUserStatus
                        ? 'cell-border-primary-right cell-border-primary-left'
                        : ''
                    }
                  >
                    {item.incomeRef2Lvl}%
                  </td>
                );
              })}
            </tr>
            <tr>
              <td className="text-left">
                {t(
                  'Доходы от рефералов <span class="text-nowrap">1 уровня</span> с пополнения баланса'
                )}
              </td>
              {this.props.itemsIds.map(itemId => {
                const item = this.props.selectItemById(itemId);

                const hasAuthUserStatus =
                  this.props.authUserRating.ratingStatusPoints >=
                    item.pointsFrom &&
                  this.props.authUserRating.ratingStatusPoints <= item.pointsTo;

                return (
                  <td
                    key={`addFundsFef1Lvl${itemId}`}
                    className={
                      hasAuthUserStatus
                        ? 'cell-border-primary-right cell-border-primary-left'
                        : ''
                    }
                  >
                    {item.addFundsFef1Lvl}%
                  </td>
                );
              })}
            </tr>
            <tr>
              <td className="text-left">
                {t(
                  'Доходы от рефералов <span class="text-nowrap">2 уровня</span> с пополнения баланса'
                )}
              </td>
              {this.props.itemsIds.map(itemId => {
                const item = this.props.selectItemById(itemId);

                const hasAuthUserStatus =
                  this.props.authUserRating.ratingStatusPoints <=
                    item.pointsTo &&
                  this.props.authUserRating.ratingStatusPoints >=
                    item.pointsFrom;

                return (
                  <td
                    key={`addFundsFef2Lvl${itemId}`}
                    className={
                      hasAuthUserStatus
                        ? 'cell-border-primary-right cell-border-primary-left'
                        : ''
                    }
                  >
                    {item.addFundsFef2Lvl}%
                  </td>
                );
              })}
            </tr>
            <tr>
              <td className="text-left">{t('Комментарии и жалобы')}</td>
              {this.props.itemsIds.map(itemId => {
                const item = this.props.selectItemById(itemId);

                const hasAuthUserStatus =
                  this.props.authUserRating.ratingStatusPoints >=
                    item.pointsFrom &&
                  this.props.authUserRating.ratingStatusPoints <= item.pointsTo;

                return (
                  <td
                    key={`commentPermissionYesOrNo${itemId}`}
                    className={
                      hasAuthUserStatus
                        ? 'cell-border-primary-right cell-border-primary-left'
                        : ''
                    }
                  >
                    {item.commentPermissionYesOrNo}
                  </td>
                );
              })}
            </tr>
            <tr>
              <td className="text-left">{t('Вывод средств')}</td>
              {this.props.itemsIds.map(itemId => {
                const item = this.props.selectItemById(itemId);

                const hasAuthUserStatus =
                  this.props.authUserRating.ratingStatusPoints >=
                    item.pointsFrom &&
                  this.props.authUserRating.ratingStatusPoints <= item.pointsTo;

                return (
                  <td
                    key={`payoutDelayDays${itemId}`}
                    className={
                      hasAuthUserStatus
                        ? 'cell-border-primary-right cell-border-primary-left cell-border-primary-bottom'
                        : ''
                    }
                  >
                    {item.payoutDelayDaysDesc}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

StatusesDescTable.propTypes = {
  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired,
    countQueries: PropTypes.number.isRequired
  }).isRequired,

  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  authUserRating: PropTypes.shape({
    ratingStatusPoints: PropTypes.number.isRequired
  }).isRequired,
  sendRequest: PropTypes.func.isRequired,
  selectItemById: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  authUserRating: selectRating(state),
  requestState: selectRequestState(state, userRatingStatusesListRN),
  itemsIds: selectItemsIds(state, userRatingStatusesListRN),
  selectItemById: id => selectItemById(state, userRatingStatusesListRN, id),
  authUserId: selectUserId(state)
});

const mapDispatchToProps = dispatch => ({
  sendRequest: () => dispatch(sendRequest(userRatingStatusesListRN))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(StatusesDescTable)
);



// WEBPACK FOOTER //
// ./src/components/Rating/StatusesDescTable/StatusesDescTable.js